import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import i18n from "i18next";

import { localeFromPath, LOCALES, DEFAULT_LOCALE } from "./lib/i18n-routes";

/**
 * Til URL yo'lidan aniqlanadi (`/ru/...`), brauzer sozlamasidan emas.
 * LanguageDetector olib tashlandi: u `?lang=` va navigator'ga qarab
 * yo'ldagi tildan boshqa tilni tanlab qo'yardi.
 */
const initialLang = typeof window !== "undefined"
  ? localeFromPath(window.location.pathname)
  : DEFAULT_LOCALE;

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: initialLang,
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: LOCALES,
    debug: false,
    interpolation: {
      escapeValue: false, // react allaqachon XSS'dan himoyalaydi
    },
    react: {
      useSuspense: false, // prerender paytida Suspense kerak emas
    },
  });

export default i18n;
